export default {"src":"/_next/static/media/pen-icon.87a610ed.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};